import { twMerge } from 'tailwind-merge';
import { DialogContent, Dialog as MuiDialog } from '@mui/material';

import { Icon } from '../icons';

import { DialogProps } from './types';

export const Dialog = ({
  open,
  title,
  onClose,
  actions,
  children,
  maxWidth = 456,
}: DialogProps) => (
  <MuiDialog
    open={open}
    scroll="paper"
    onClose={onClose}
    slotProps={{
      paper: {
        sx: {
          maxWidth,
          width: '100%',
        },
      },
      backdrop: {
        sx: (theme) => ({
          background: `${theme.palette.black.primary}99`,
        }),
      },
    }}
  >
    {title && (
      <div className="flex items-start justify-between gap-4 px-4 pt-5 pb-2 md:px-6 md:pt-6 md:pb-4">
        <h3 className="text-lg md:text-2xl">{title}</h3>
        <button
          type="button"
          onClick={onClose}
          className="md-mt-2 flex flex-shrink-0 cursor-pointer md:-mr-2"
        >
          <Icon.Close />
        </button>
      </div>
    )}
    <DialogContent
      className={twMerge('p-4 md:p-6', actions && '!pb-0', title && '!pt-0')}
    >
      {children}
    </DialogContent>
    {actions && (
      <div className="flex gap-4 p-4 md:gap-6 md:p-6 [&>*]:flex-1">
        {actions}
      </div>
    )}
  </MuiDialog>
);
